var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a",
    {
      staticClass: "nav-link",
      attrs: {
        href: _vm.urlWishList,
        rel: "nofollow",
        "aria-label": _vm.$translate("Ceres::Template.wishList")
      }
    },
    [
      _c("span", { staticClass: "badge-right" }, [
        _vm._v(_vm._s(_vm.wishListCount))
      ]),
      _vm._v(" "),
      _c("img", {
        attrs: {
          src: _vm.pluginPathTheme + "/images/wishlist.svg",
          alt: "wishlist"
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }